import type {VendorPixel} from '../types/analytics/vendor-pixel'

/**
 * Fires a single vendor tracking pixel by creating a 1×1 image.
 * The request is fire-and-forget — no response handling needed.
 */
export function fireVendorPixel(url: string): void {
  const img = new Image(1, 1)
  img.src = url
}

/**
 * Fires a tracking pixel for each vendor.
 * When `firedKeys` is provided, pixels whose key is already in the Set are
 * skipped, and newly fired pixel keys are added to the Set.
 */
export function firePixelsOnClick(pixels: VendorPixel[], firedKeys?: Set<string>): void {
  for (const pixel of pixels) {
    // Skip firing a tracking pixel if pixel vendor key is present. This way it only fires once.
    if (firedKeys?.has(pixel.key)) continue

    fireVendorPixel(pixel.clickEventUrl)

    if (firedKeys) {
      firedKeys.add(pixel.key)
    }
  }
}
